var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.82 34.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.49,17.37c3.73,2.03,15.33,8.26,15.33,12.14,0,3.11-2,5.23-4.88,5.23-2.41,0-3.23-1.29-3.23-2.94s.53-2.59,1.65-2.59c1.18,0,1.7.76,3.35.76,1.35,0,1.63-1.46.94-2.49-2.27-3.4-17.57-8.72-21.65-10.13,4.08-1.4,19.38-6.72,21.65-10.13.68-1.03.41-2.49-.94-2.49-1.65,0-2.17.76-3.35.76s-1.65-1-1.65-2.59.82-2.94,3.23-2.94c2.88,0,4.88,2.12,4.88,5.23,0,3.88-11.6,10.11-15.33,12.14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.8b0a05b1520f79704b8be1f9a1fc76fa.svg";
export { ForwardRef as ReactComponent };